
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualiseringer',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Oppgi et tall',
	'maxValuePlaceholder': 'Oppgi et tall',
	'customRangeErrorMessage': 'Verdien må være et tall',
	'propFillColor': 'Fyllfarge',
	'propBorderColor': 'Kantlinjefarge',
	'propColorPalette': 'Gjeldende fargepalett',
	'propColorPaletteChangeLabel': 'Endre fargepalett',
	'propNewColorPaletteLabel': 'Opprett en tilpasset fargepalett',
	'propNewHeatPaletteLabel': 'Opprett en tilpasset varmepalett',
	'propDonutRadius': 'Smultringdiagramradius',
	'showTitleLabel': 'Vis tittel',
	'titleTypeLabel': 'Titteltype',
	'smartTitleLabel': 'Smart tittel',
	'customTitleLabel': 'Tilpasset tittel',
	'noTitleLabel': 'Ingen tittel',
	'propHeatScalePalette': 'Gjeldende varmepalett',
	'propHeatPaletteChangeLabel': 'Endre varmepalett',
	'propMaintainAxisScales': 'Vedlikehold akseskala',
	'propLineAndSymbolColor': 'Linje- og symbolfarge',
	'propLineAndSymbolPalette': 'Linje- og symbolfargepalett',
	'propElementColor': 'Elementfarge',
	'propColumnColor': 'Kolonnefarge',
	'propColumnPalette': 'Kolonnefargepalett',
	'propColumnHeatPalette': 'Kolonnevarmepalett',
	'propBarColor': 'Stolpefarge',
	'propGoalColor': 'Målfarge',
	'propToColor': 'Til-farge',
	'propFromColor': 'Fra-farge',
	'propNumberValidationErrorMessageId': 'Oppgi et tall',
	'fontSizeAuto': 'Automatisk',
	'propAutoBinCount': 'Antall grupper',
	'propAutoBinToggle': 'Automatisk gruppering',
	'tabName_general': 'Generelt',
	'tabName_visDetails': 'Detaljer',
	'tabName_animation': 'Animasjon',
	'tabName_mediaDetails': 'Mediedetaljer',
	'tabName_webDetails': 'Websidedetaljer',
	'tabName_imageDetails': 'Bildedetaljer',
	'tabName_visualization': 'Visualisering',
	'tabName_text': 'Tekst',
	'sectionName_colorsAndThemes': 'Farge og temaer',
	'sectionName_appearance': 'Utseende',
	'sectionName_general': 'Generelt',
	'sectionName_colorPalette': 'Farge',
	'sectionName_axis': 'Akse',
	'sectionName_axis_label': 'Akse',
	'sectionName_legend': 'Forklaring',
	'sectionName_chart': 'Diagram',
	'sectionName_regionLayer': 'Regionlag',
	'sectionName_pointLayer': 'Punktlag',
	'sectionName_latLongLayer': 'Breddegrad/lengdegrad-lag',
	'sectionName_pathLayer': 'Banelag',
	'sectionName_xAxis': 'X-akse',
	'sectionName_yAxis': 'Y-akse',
	'sectionName_xAxis_title': 'Tittel på X-akse',
	'sectionName_yAxis_title': 'Tittel på Y-akse',
	'sectionName_xAxis_label': 'X-akseetikett',
	'sectionName_yAxis_label': 'Y-akseetikett',
	'sectionName_column_yAxis': 'Y-akse for kolonne',
	'sectionName_column_yAxis_label': 'Y-akseetikett for kolonne',
	'sectionName_column_yAxis_title': 'Y-aksetittel for kolonne',
	'sectionName_line_yAxis': 'Y-akse for linje',
	'sectionName_line_yAxis_label': 'Y-akseetikett for linje',
	'sectionName_line_yAxis_title': 'Y-aksetittel for linje',
	'sectionName_title': 'Tittel',
	'sectionName_dataValueLabels': 'Dataverdietiketter',
	'sectionName_style': 'Stil',
	'propTransparencyDescription': 'Gjør objektet mer eller mindre gjennomsiktig. Skriv en verdi mellom 0 og 100',
	'smart_annotation_unauthorized': 'Annotasjoner: Uautorisert tilgang',
	'smart_annotation_method': 'Annotasjoner: Metode ikke tillatt',
	'smart_annotation_media': 'Annotasjoner: Medietype ikke tillatt',
	'smart_annotation_input': 'Annotasjoner: Inndata ugyldige',
	'smart_annotation_internal': 'Annotasjoner: Intern systemfeil',
	'smart_annotation_generic_error': 'Annotasjoner: Tjenestefeil',
	'smart_annotation_dialog_title': 'Innsikt',
	'smart_annotation_Show_Insights': 'Vis innsikter',
	'smart_annotation_Relationship': 'Relasjonen er',
	'forecast_enter_number': 'Oppgi et tall mellom ',
	'and': ' og ',
	'smart_errors': 'Annotasjonsfeil:',
	'smart_warnings': 'Annotasjonsadvarsler:',
	'smart_annotation_insight_icon_title': 'Innsikt',
	'smart_annotations_toggle_on': 'Slå innsikt på',
	'smart_annotations_toggle_off': 'Slå innsikt av',
	'smart_annotation_toggle_on': 'Slå på',
	'smart_annotation_toggle_off': 'Slå av',
	'smart_annotation_insight_unavailable': 'Innsikt er ikke tilgjengelig nå',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Innsikt er ikke tilgjengelig når et filter for Topp eller Bunn % blir brukt',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Prognose er ikke tilgjengelig når et filter for Topp eller Bunn % blir brukt',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Innsikt er ikke tilgjengelig når et topp- eller bunnfilter blir brukt, og det ikke er mer enn én kolonne i feltet',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Prognose er ikke tilgjengelig når et topp- eller bunnfilter blir brukt, og det ikke er mer enn én kolonne i feltet',
	'forecast_title': 'Prognose',
	'forecast_show': 'Vis prognose',
	'forecast_toggle_on': 'Slå prognose på',
	'forecast_toggle_off': 'Slå prognose av',
	'statDetailsPerspectiveTitle': 'Analyse',
	'emptyStatDetailsPanel': 'Ingen ytterligere analyse tilgjengelig for gjeldende visualisering.',
	'predict_errors': 'Analysefeil',
	'predict_warnings': 'Analysadvarsler',
	'fpd_invalid_data_source': 'Denne datakilden har ikke en tilknyttet smarts-modul.',
	'fpd_network_issue': 'Det oppstod et problem ved utføring av en analyse mot denne datakilden',
	'fpd_data_source_category': 'Smarts-modul mangler',
	'fpd_response_errors': 'Feil for anbefalt driver',
	'fpd_response_warnings': 'Advarsler for anbefalt driver',
	'catalyst_service_bad_request': 'Ugyldig forespørsel',
	'catalyst_service_unkown_Id': 'Ukjent forespørsel-ID funnet',
	'catalyst_service_internal_server_error': 'Intern serverfeil',
	'catalyst_service_generic_error': 'Katalysatortjenestefeil',
	'catalyst_service_error': 'Denne tjenesten er ikke tilgjengelig nå',
	'propLegendPosition': 'Posisjon for forklaring',
	'propLeft': 'Venstre',
	'propRight': 'Høyre',
	'propTop': 'Øverst',
	'propBottom': 'Nederst',
	'propNone': 'Ingen',
	'propLegendDisplay': 'Vis forklaring',
	'targetThicknessPlaceHolder': '%{min} til %{max}',
	'targetThicknessErrorMsg': 'Oppgi et heltall mellom %{min} og %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Drivere (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'valgt)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Tilbakestill til standardverdier',
	'possibelKeyDriver_AddNewDrivers': 'Legg til flere drivere',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Søk for å legge til flere drivere',
	'possibleKeyDrivers_MaxPossibleReached': 'Opphev valget av noen drivere for å legge til eller velge andre',
	'possibleKeyDrivers_Recommended': 'Anbefalte',
	'visRecommendedTypes': 'Anbefalte visualiseringstyper',
	'visRecommender_smartsfailure': 'visualiseringsanbefalinger er ikke tilgjengelig nå',
	'visMore': 'Mer...',
	'visMoreTooltip': 'Flere visualiseringer',
	'visOtherTypes': 'Andre visualiseringstyper',
	'visChange': 'Endre visualisering',
	'automaticTypeCaption': 'Automatisk',
	'propVisType': 'Visualiseringstyper',
	'dlg_loading': 'Laster inn...',
	'snippetListChartCaption': 'Snuttliste',
	'convoClusterChartCaption': 'Samtaleklynge',
	'areaChartCaption': 'Område',
	'barChartCaption': 'Stolpe',
	'columnChartCaption': 'Kolonne',
	'stackedbarChartCaption': 'Stablet stolpe',
	'stackedcolumnChartCaption': 'Stablet kolonne',
	'bubbleChartCaption': 'Boble',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Driveranalyse',
	'scatterChartCaption': 'Spredning',
	'lineChartCaption': 'Linje',
	'pointChartCaption': 'Punkt',
	'heatChartCaption': 'Varmekart',
	'bulletChartCaption': 'Punkt',
	'waterfallChartCaption': 'Foss',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Boksplott',
	'pieChartCaption': 'Sektor',
	'mapChartCaption': 'Kart',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Linje og kolonne',
	'wordCloudChartCaption': 'Ordsky',
	'networkChartCaption': 'Nettverk',
	'relationshipNetworkChartCaption': 'Relasjonsnettverk',
	'treemapChartCaption': 'Treoversikt',
	'packedBubbleChartCaption': 'Pakket boble',
	'hierarcicalPackedBubbleChartCaption': 'Hierarkiboble',
	'spiralChartCaption': 'Spiral',
	'decisionTreeChartCaption': 'Beslutningstre',
	'legacyMapChartCaption': 'Gammelt kart',
	'sunburstChartCaption': 'Solstråle',
	'visUsageComparison': 'Sammenlikning',
	'visUsageRelationships': 'Relasjoner',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Deler til hele',
	'visUsageGeospatial': 'Georom',
	'visUsageAdvanced': 'Avansert analyse',
	'visUsageTablesAndSummary': 'Tabeller og sammendrag',
	'visUsageSocialInsights': 'Sosial innsikt',
	'visUsageOther': 'Annet',
	'autoBinActionText': 'Grupper automatisk',
	'filterAutobinActionText': 'Filtrer binger',
	'memberCalculationActionText': 'Medlemsberegning',
	'toolbarActionCalculation': 'Opprett beregning',
	'toolbarActionEditCalculation': 'Rediger beregning',
	'topBottomRankLabel': 'Rangering (%{label})',
	'toolbarDeleteFilterActionText': 'Fjern filter',
	'toolbarActionTopKeyDrivers': 'Vis drivere',
	'toolbarActionCustomGroup': 'Tilpasset gruppe',
	'canNotCreateCustomGroup': 'Ikke mulig å opprette denne tilpassede gruppen.',
	'aria_label_datatable': 'Datatabell',
	'summaryCaption': 'Sammendrag',
	'MeasuresCaption': 'Måleverdier',
	'MeasuresGroupCaption': 'Måleverdigruppe (%{count})',
	'ValuesCaption': 'Verdier',
	'turnInsightsOn': 'Slå innsikt på',
	'turnInsightsOff': 'Slå innsikt av',
	'decisionRules': 'Regler',
	'decisionTree': 'Trediagram',
	'decisionSunburst': 'Tresolstråle',
	'switchToDecisionRules': 'Bytt til beslutningsregler',
	'switchToDecisionTree': 'Bytt til beslutningstre',
	'data_group_less_then': 'mindre enn %{rangeTo}',
	'data_group_to': '%{rangeFrom} til < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} og over',
	'nullValueContent': '(ingen verdi)',
	'sum': 'Sum',
	'count': 'Tell',
	'countdistinct': 'Tell entydige',
	'avg': 'Gjennomsnitt',
	'min': 'Minimum',
	'max': 'Maksimum',
	'automatic': 'Tilpasset',
	'variance': 'Varians',
	'stddev': 'Standardavvik',
	'median': 'Median',
	'calculated': 'Beregnet',
	'none': 'Ingen',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Forespørselsverdier',
	'inputLabelPrompt': 'Verdi',
	'inputPlaceholderPrompt': 'Oppgi verdi',
	'inputInvalidText': 'Ugyldige inndata for %{dataType}-type',
	'unSupportedPrompt': 'Ikke støttet forespørsel',
	'missingDataSource': 'Fant ikke riktig datakilde.',
	'unSupportedPromptType': 'Forespørselsscenariet støttes ikke nå.',
	'preAggregateLabel': 'Bruk forespørselsverdier fra datakilden',
	'postAggregateLabel': 'Bruk forespørselsverdier i rapporten',
	'preAggregateText': 'Området bruker verdiene i datakilden, ikke verdiene som blir vist på dashbordet.',
	'defaultAggregation_count': 'Tell',
	'defaultAggregation_countdistinct': 'Tell entydige',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Gjennomsnitt',
	'defaultAggregation_sum': 'Sum',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Gjennomsnitt totalt',
	'keydriver_up_down': 'Uthevede grupper med høyt eller lavt gjennomsnitt har mer innvirkning på målet. Grupper med uvanlig høyt eller lavt gjennomsnitt har sterkest innvirkning.',
	'keydriver_different': 'Uthevede grupper har fordelinger som skiller seg vesentlig fra den totalt fordelingen. Disse gruppene har mer innvirkning på målet.',
	'topOperator': 'Øverst',
	'bottomOperator': 'Nederst',
	'topBottomFact': '%{operator} %{value}%{percent} etter %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Slett øverste eller nederste antall',
	'deleteTopBottomPercent': 'Slett øverste eller nederste prosent',
	'topBottomTitle': 'Bare dette objektet',
	'deleteTopBottom': 'Slett øverste eller nederste antall',
	'editTopBottom': 'Rediger øverste eller nederste antall',
	'editTopBottomCount': 'Rediger øverste eller nederste antall',
	'editTopBottomPercent': 'Rediger øverste eller nederste prosent',
	'ariaDeleteTopBottomCountLabel': 'Trykk på DELETE-tasten for å slette øverste eller nederste antall.',
	'ariaDeleteTopBottomPercentLabel': 'Trykk på DELETE-tasten for å slette øverste eller nederste prosent.',
	'ariaEditTopBottomCountLabel': 'Trykk på Enter for å redigere øverste eller nederste antall.',
	'ariaEditTopBottomPercentLabel': 'Trykk på Enter for å redigere øverste eller nederste prosent.',
	'ariaDeleteDrillStateLabel': 'Trykk på Enter for å redigere øverste eller nederste antall.',
	'drillUpStateTitle': 'Drilling oppover',
	'drillDownStateTitle': 'Drill nedover',
	'ariaEditTopBottomLabel': 'Trykk på Enter for å redigere øverste eller nederste antall.',
	'ariaDeleteTopBottomLabel': 'Trykk på DELETE-tasten for å slette øverste eller nederste antall.',
	'allKeyDriversLabel': 'Auto (alle drivere)',
	'filter_drag_and_drop_single_dock': 'Dra og slipp data her for å filtrere.',
	'filter_drag_and_drop_all_tabs': 'Dra og slipp data her for å filtrere alle flipper.',
	'filter_drag_and_drop_current_tab': 'Dra og slipp data her for å filtrere denne flippen.',
	'filter_empty_consume_mode': 'Ingen filtre er brukt.',
	'filterClearAllItems': 'Fjern alle filtre',
	'filterDeleteAllItems': 'Slett alle filtre',
	'filterDockChevronLeft': 'Bla gjennom dataene',
	'filterDockChevronRight': 'Bla gjennom dataene',
	'filterIconLabel_Single': 'Filtrerer',
	'filterIconLabel_Global': 'Alle flipper',
	'filterIconLabel_Tab': 'Denne flippen',
	'filterIconTooltip_Single': 'Filtrerer',
	'filterIconTooltip_Global': 'Filtre for alle flipper',
	'filterIconTooltip_Tab': 'Filtre for denne flippen',
	'filterDropZoneTooltip_Single': 'Filterslippsone',
	'filterDropZoneTooltip_Global': 'Filterslippsone for alle flipper',
	'filterDropZoneTooltip_Tab': 'Filterslippsone for denne flippen',
	'filterOverflowMenu': 'Mer',
	'expand': 'Utvid',
	'collapse': 'Komprimer',
	'filterDockItemNameAriaLabel': 'Trykk på Enter for å åpne filterdialogboksen og definere filteret.',
	'filterItemCanvasMove': 'Legg til på lerret',
	'filterItemDelete': 'Slett filter',
	'filterInvertRange': 'alt unntatt: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Ikke etter %{from}',
	'filter_date_after': 'Etter %{from}',
	'filter_date_before_except': 'Ikke før %{to}',
	'filter_date_before': 'Før %{to}',
	'filter_date_between_except': 'Ikke mellom %{from}-%{to}',
	'filter_date_between': 'Mellom %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Alle',
	'filter': 'Filter',
	'filterExcept': 'unntatt %{values}',
	'filterDockToolbarButtonLabel': 'Filtrer dokk',
	'navigateTitle': 'Naviger til',
	'navigateSelectColumn': 'Velg en kolonne',
	'navigateSelectPath': 'Velg en navigeringsbane',
	'current_nav_group': 'Gjeldende navigeringsgruppe er %{navigation_group_name}',
	'next': 'Neste',
	'previous': 'Forrige',
	'multiselectMsg': '%{count} valgt',
	'errMsgFilterItemMissingTitle': 'Filterverdien(e) %{itemName} kan ikke lastes inn fordi disse verdiene ikke er tilgjengelige med dette datasettet',
	'errMsgFilterItemGenericTitle': 'Filterverdier kan ikke lastes inn',
	'textFilterItemsNotFound': 'Ingen elementer tilgjengelig.',
	'nullValueLabel': '(tom)',
	'filterConditionLabel': 'Filterbetingelse',
	'filter_includesAll': 'Inkluderer alle',
	'filter_allMembersOfSet': 'Alle medlemmer i settet',
	'modelFilter': 'Filter',
	'filtersTitle': 'Filteregenskaper',
	'search': 'Søk',
	'clearTextFilterValue': 'Fjern',
	'invertFilterSelection': 'Inverter',
	'modellingLoading': 'Laster inn...',
	'searchAll': 'Søk etter alle kolonner',
	'toolbarActionPossibleKeyDrivers': 'Rediger omfang',
	'toolbarActionPossibleKeyDriversSubTitle': 'Dra elementer fra venstre som skal vurderes i driveranalysediagrammet',
	'toolbarActionSort': 'Sorter',
	'toolbarActionSortAscending': 'Stigende',
	'toolbarActionSortDescending': 'Synkende',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Tilpasset',
	'toolbarActionFormat': 'Formatdata',
	'toolbarActionFormatText': 'Formater data (tekst)',
	'toolbarActionFormatAbbreviation': 'Forkort',
	'toolbarActionFormatNone': 'Automatisk',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Øverste eller nederste',
	'toolbarActionRmvShape': 'Fjern form',
	'toolbarActionToggleShapeDrop': 'Infografikkform',
	'toolbarActionToggleShapeDropTitle': 'Opprett en infografikk',
	'toolbarActionToggleShapeDropText': 'Dra en form til dette feltet for å opprette en infografikk.',
	'toolbarActionAggregationType': 'Sammenfatt',
	'toolbarDeleteActionText': 'Fjern kolonne',
	'toolbarTextActionText': 'Stiltekst',
	'toolbarActionFilterLocalKeepSelected': 'Behold',
	'toolbarActionFilterLocalExcludeSelected': 'Ekskluder',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Enkel beregning',
	'toolbarActionDrillBack': 'Tilbake',
	'toolbarActionDrillUp': 'Drilling oppover',
	'toolbarActionDrillDown': 'Drill nedover',
	'toolbarActionJumpTo': 'Drill gjennom',
	'toolbarActionNavigate': 'Naviger',
	'toolbarActionCreateFilterGroup': 'Opprett ny tilkobling',
	'toolbarActionDisconnectFilterGroup': 'Bryt alle linker',
	'toolbarActionLinkFilterGroup': 'Legg til en eksisterende tilkobling',
	'toolbarActionLassoSelect': 'Valgverktøy',
	'toolbarActionRefreshDeveloperWidget': 'Oppdater',
	'textFontFamilySubClassHairline': 'Hårstrek',
	'textFontFamilySubClassThin': 'Tynn',
	'textFontFamilySubClassThinItalic': 'Tynn kursiv',
	'textFontFamilySubClassExtraLight': 'Ekstra lett',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra lett kursiv',
	'textFontFamilySubClassLight': 'Lett',
	'textFontFamilySubClassLightItalic': 'Lett kursiv',
	'textFontFamilySubClassRegular': 'Vanlig',
	'textFontFamilySubClassRegularItalic': 'Vanlig kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Middels',
	'textFontFamilySubClassMediumItalic': 'Middels kursiv',
	'textFontFamilySubClassHeavy': 'Tung',
	'textFontFamilySubClassHeavyItalic': 'Tung kursiv',
	'textFontFamilySubClassDemiBold': 'Halvfet',
	'textFontFamilySubClassDemiBoldItalic': 'Halvfet kursiv',
	'textFontFamilySubClassBold': 'Fet',
	'textFontFamilySubClassBoldItalic': 'Fet kursiv',
	'textFontFamilySubClassExtraBold': 'Ekstra fet',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra fet kursiv',
	'textFontFamilySubClassBlack': 'Svart',
	'textFontFamilySubClassBlackItalic': 'Svart kursiv',
	'textFontFamilySubClassStencil': 'Sjablong',
	'dlg_ascending': 'stigende',
	'dlg_descending': 'synkende',
	'dlg_custom': 'tilpasset',
	'dlg_none': 'ingen',
	'dlg_hierarchy': 'hierarki',
	'dlg_namedSet': 'navngitt sett',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Visualisering',
	'chartLabel': 'Diagrammet %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Trykk på F12 for å navigere i widgeten',
	'f10KeyDescription': 'Trykk på F10 for å starte widgetfokusvisningen',
	'playButtonLabel': 'Spill',
	'dataPlayerValueListLabel': 'Dataspillerverdier',
	'localFilterTitle': 'Bare dette objektet',
	'globalFilterTitle': 'Alle objekter',
	'deleteFilter': 'Slett filter',
	'editFilter': 'Rediger filter',
	'ariaEditFilterLabel': 'Trykk på Enter for å redigere filteret.',
	'ariaDeleteFilterLabel': 'Trykk på DELETE-tasten for å slette filteret.',
	'measureFilterBetween': 'Mellom %{lowerBound} og %{upperBound}',
	'measureFilterNotBetween': 'Ikke mellom %{lowerBound} og %{upperBound}',
	'dimFilterIn': 'Inkluderer: %{in}',
	'dimFilterNotIn': 'Ekskluderer: %{out}',
	'gtFilter': 'Etter %{lowerBound}',
	'ltFilter': 'Før %{upperBound}',
	'ariaEditPrompt': 'Trykk på Enter for å endre forespørselsverdien',
	'dataPointFilterTitle': 'Datapunkter',
	'dataPointFilterIncludeSummary': 'Inkludert %{valueCount} datapunkter',
	'dataPointFilterExcludeSummary': 'Ekskluderte %{valueCount} datapunkter',
	'widgetFiltersLabel': 'Widgetfiltre',
	'coachMarkTitleSpiralTarget': 'Rediger omfang',
	'coachMarkContentSpiralTarget': 'Her får du tilgang til og kan endre drivervalget for målet ditt.',
	'srILVTreeLabel': 'Liste',
	'geomapUnrecognizedLocations': 'Ukjente steder:',
	'geomapAmbiguousLocations': 'Tvetydige regioner:',
	'visualizationNotifications': 'Visualiseringsvarsler:',
	'dataNotifications': 'Datavarsler:',
	'autobinSuggestion': 'Slå på automatisk gruppering',
	'LIVE_empty_visualization_hint_title': 'Bygg visualiseringen din',
	'LIVE_empty_visualization_hint_description': 'Dra data hit eller til feltene.',
	'LIVE_slots_required_field_description': '%{asterisk} Angir et obligatorisk felt',
	'LIVE_slots_drag_and_drop_description': 'Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.',
	'dwErrorLoadingAvailableVisualizations': 'Kan ikke laste inn de tilgjengelige visualiseringsdefinisjonene',
	'moreDataIndicator': 'Dataene dine ble kuttet ved %{threshold} elementer. Bruk et filter for å vise færre.',
	'nonCtxTopBottomInvalid': 'Definering av en øvre eller nedre regel uten en kontekst støttes ikke for krysstabuleringer. Det ble fjernet fra denne krysstabellvisningen.  Omdefiner regelen på en eller flere kategorier i konteksten %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Kan ikke laste inn objektet fordi det mangler en visualiseringsdefinisjon.',
	'dwErrorLoadingVisualizationListNotFound': 'Kan ikke laste inn visualiseringen.',
	'dwErrorRunningQuery': 'Kan ikke hente dataene fra datasett %{datasetName}.',
	'dwErrorGeoData': 'Problemer med å vise de geografiske dataene i et kart. Velg en annen visualiseringstype.',
	'dwPromptSignonCancelWarning': 'Dataene for denne visualiseringen er ikke tilgjengelige. Oppgi riktig legitimasjon.',
	'dwErrorMissingDataset': 'Kan ikke laste inn visualiseringen fordi det tilknyttede datasettet "%{datasetName}" ikke er tilgjengelig.',
	'dwErrorRenderingVisualization': 'Kan ikke laste inn denne visualiseringen.',
	'dwErrorVisualizationTooSmall': 'Visualiseringen er for liten for å vise dataene den inneholder. Gjør visualiseringen større eller begrens dataene den inneholder.',
	'errorSourceNotFound': 'Kan ikke laste inn visualiseringen fordi den tilknyttede kilden "%{sourceName}" ikke er tilgjengelig.',
	'errorActionNotSupported': 'Denne handlingen støttes ikke for datakilden "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'Visualiseringen har måleverdier på flere kanter, noe som ikke lenger støttes. Plasser måleverdier på bare en kant.',
	'errorExceedAllowableValue': 'Det beregnede antall celler overskrider den tillatte verdien på 100000. Bruk filtrering på projiserte sett for å redusere antall celler.',
	'propScaleLabel': 'Antall ikoner',
	'propScaleDescription': 'Velg antall ikoner',
	'propScaleFew': 'Lav',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Høy',
	'lastRefresh': 'Siste oppdatering: for %{timeInterval} siden',
	'widgetTimer': 'Widgettidtaker',
	'datasetItemsUnavailable': 'Noen av datasettelementene som er brukt i denne visualiseringen, er ikke tilgjengelige.',
	'datasetItemUnavailable': 'Dette datasettelementet er ikke tilgjengelig',
	'retry': 'Prøv på nytt',
	'widgetConditionalFormatLabel': 'Slå betingede formatkontroller på/av',
	'widgetConditionalFormatTitle': 'Rediger farge for betinget formatering',
	'crosstabName': 'Krysstabell',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Ikke tilgjengelig',
	'summaryLabel': '%{label} med verdien %{value}',
	'infographicLabel': '%{label} med verdien %{value}',
	'warning': 'Advarsel',
	'swapRowsAndColumns': 'Bytt rader og kolonner',
	'hideSummariesLabel': 'Skjul sammendrag',
	'showSummariesLabel': 'Vis sammendrag',
	'hideRowColumn': 'Skjul',
	'showAllRowColumn': 'Vis alle',
	'dataAssetPropertiesLabel': 'Visualiseringsegenskaper',
	'evAdd': 'Legg til en kolonne',
	'evCollapse': 'Komprimer',
	'evColumns': 'Kolonner',
	'evLocalFilters': 'Lokale filtre',
	'evExpand': 'Utvid',
	'evFilterTooltip': 'Filter',
	'missingColumn': 'Mangler: %{columnLabel}',
	'missingFiltering': 'Mangler filtre på kolonner:',
	'missingDataItem': 'Fant ikke det refererte dataelementet "%{dataItemId}" i widgeten.',
	'heatByLabel': 'Varme etter',
	'toolbarChangeVisualization': 'Endre visualisering',
	'modellingRelatedTablesNoneFound': 'Fant ingen beslektede tabeller',
	'processing': 'Behandler...',
	'errorCellWarning': 'Noen sammendragsverdier kunne ikke beregnes.',
	'aggregateTypeToggler': 'Vis aggregeringstype',
	'maxColumnsExceeded': 'Maksimalt antall kolonner overskredet. %{columns} fjernet.',
	'unboundColumns': 'Kan ikke bruke følgende kolonner: %{columns}.',
	'unboundColumn': 'Kan ikke bruke følgende kolonne: %{columns}.',
	'recommendRequestFailed': 'Anbefalingsforespørsel mislyktes. Kontakt administratoren.',
	'visualizationDoesNotSupportOLAP': 'Vi kan ikke opprette denne visualiseringen som er basert på en OLAP-datakilde. Bruk en annen støttet datakilde.',
	'showDataBehindVizLabel': 'Vis data',
	'showDataBehindVizNotSupportedLabel': 'Alternativet Vis data støttes ikke for denne visualiseringstypen',
	'exploreData': 'Utforsk ...',
	'newExplore': 'Ny utforsking',
	'thumbnails_error_fetching': 'Feil ved henting av miniatyrbilder',
	'loadedThumbnailImage': 'Lastet inn miniatyrbildet for %{visType}-visualiseringen',
	'autobinAxisLabel': 'grupper',
	'recommended_visualizations': 'Anbefalte visualiseringer',
	'all_visualizations': 'Alle visualiseringer',
	'edit': 'Rediger',
	'selectTargetDialogTitle': 'Velg et gjennomdrillingsmål',
	'noTargetInCM': 'Fant ikke målet for gjennomdrillingen',
	'errorDrillDefinition': 'Noe gikk galt mens du la til eller redigerte gjennomdrillingsdefinisjonen.',
	'errorDrillToTarget': 'Det oppstod en feil ved drilling til "%{targetName}"',
	'drillThroughMappingViewLabel': 'Tildel kolonner fra dashbordet ditt til forespørslene for målrapporten',
	'drillthroughScopeRadioLabel': 'Bruk denne definisjonen på:',
	'drillthroughScopeRadioOptionVisualization': 'Bare denne visualiseringen',
	'drillthroughScopeRadioOptionConnection': 'Visualiseringer i samme tilkobling som bruker samme datakilde',
	'drillthroughScopeRadioOptionDashboard': 'Enhver visualisering på %{perspective} som bruker samme datakilde',
	'drillThroughParametersColumnTitle': '"%{targetName}"-forespørsler:',
	'drillThroughMetadataColumnTitle': '"%{boardName}"-datakolonner:',
	'drillThroughDefinitionNoParameter': 'Gjennomdrillingsmålet har ingen forespørsler.',
	'drillThroughDefinitionErrorQueryingReport': 'Løs problemet med målrapporten og prøv deretter å opprette gjennomdrillingsdefinisjonen igjen.',
	'drillThroughDefinitionErrorDlgTitle': 'Noe gikk galt',
	'dlg_back': 'Gå tilbake',
	'dlg_close': 'Lukk',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Avbryt',
	'dlg_apply': 'Bruk',
	'dlg_create': 'Opprett',
	'dlg_done': 'Ferdig',
	'drillthrough_unsaveMsg': 'Fortsette uten å lagre "%{name}"?',
	'drillthrough_jumpTo': 'Gjennomdrillingsdefinisjon: %{name}',
	'drillthrough_jumpToLabel': 'Drill gjennom',
	'drillthrough_manage': 'Administrer...',
	'drillthrough_addNewTarget': 'Legg til en ny gjennomdrillingsdefinisjon',
	'drillthrough_manageJumpPaths': 'Administrer gjennomdrillingsdefinisjoner',
	'drillthrough_manageJumpPaths_edit': 'Rediger "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Slett "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Legg til en gjennomdrillingsdefinisjon til',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Bekreft sletting',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Er du sikker på at du vil slette gjennomdrillingen "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplikatnavn for gjennomdrilling',
	'drillthrough_definitionMessage': 'Gjennomdrillingen "%{name}" finnes allerede. Oppgi et annet navn',
	'drillthrough_jumpToTarget_notFound': 'Målet ble ikke funnet for gjennomdrilling "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Det vil ikke bli sendt noen kontekst til målrapporten.',
	'drillthrough_titleLabel': 'Navn',
	'drillthrough_create_dialogTitle': 'Opprett gjennomdrillingsdefinisjon',
	'drillthrough_edit_dialogTitle': 'Rediger gjennomdrillingsdefinisjon',
	'drillthrough_subTitle': 'Konteksten for visualiseringen i kilden din brukes til å filtrere målet %{perspective}.',
	'drillthrough_selectColumn': 'Velg en kolonne',
	'noPrompt': 'Ingen forespørsler',
	'promptDialog': 'Forespørselsdialogboksen %{promptType}',
	'formatAutoDescription': 'Auto angir formatet som er arvet fra datakilden eller visualiseringen',
	'formatDefaultDescription': 'Standard angir formatet som er arvet fra systemet',
	'createCustomGroupAction': 'Opprett datagruppe',
	'removeCustomGroupAction': 'Fjern datagruppe',
	'editCustomGroupAction': 'Rediger datagruppe',
	'renameCustomGroupAction': 'Endre navn på datagruppe',
	'createCustomGroupErrorToast': 'Datagruppen kunne ikke opprettes.',
	'removeCustomGroupErrorToast': 'Datagruppen kunne ikke fjernes.',
	'editCustomGroupErrorToast': 'Datagruppen kunne ikke redigeres.',
	'renameCustomGroupErrorToast': 'Navnet på datagruppen kunne ikke endres.',
	'customGroupLabel': 'Opprett datagruppe',
	'ungroupCustomGroupLabel': 'Opphev gruppering',
	'renameCustomGroupLabel': 'Endre navn',
	'createCustomGroupLabel': 'Opprett',
	'customGroupingLabel': '%{columnLabel} (Gruppe)',
	'createCustomSort': 'Opprett tilpasset sortering',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Velg tilgjengelige elementer og endre deretter rekkefølgen på dem for å opprette en tilpasset sortering.',
	'availableItems': 'Tilgjengelige elementer',
	'selectAll': 'Velg alle',
	'customSortOrder': 'Tilpasset sorteringsrekkefølge',
	'selectAvailableItemsDesc': 'Velg tilgjengelige elementer og endre deretter rekkefølgen på dem her.',
	'moveToTop': 'Flytt øverst',
	'clear': 'Fjern',
	'sortRemainingItemsBy': 'Sorter resterende elementer etter',
	'removeAll': 'Fjern alle',
	'resetTooltip': 'Alle elementer vil bli fjernet fra %{customSortOrder}-listen. Og rullegardinlisten %{sortRemainingItemsBy} vil bli tilbakestilt til standard.',
	'manyItemsWarning': 'Hvis du velger mange elementer, kan det påvirke dashbordets ytelse.',
	'manyItemsSelected': 'Mer enn %{maxItems} elementer er valgt, og dette kan påvirke dashbordets ytelse.',
	'somethingWentWrong': 'Beklager. Noe gikk galt.',
	'tryAgain': 'Prøv igjen',
	'customSortLabel': 'Tilpasset sortering',
	'applyError': 'Kan ikke ta i bruk %{action}.',
	'searchReturnedNoResults': 'Søket ditt returnerte ingen resultater.',
	'extVisSystem': 'System',
	'extVisCustom': 'Tilpasset',
	'customVisTestVisualization': 'Test visualisering',
	'extVisCustomVisPreview': 'forhåndsvisning',
	'extVisCustomPreviewWidgets': 'Utviklerwidgeter',
	'extVisCustomVVisualization': 'Visualisering',
	'extVisCustomVisuals': 'Tilpassede visuelle elementer',
	'noPermissionToManage': 'Du har ikke tillatelse til å administrere tilpassede visualiseringer.',
	'extVisCustomUpdate': 'Oppdater',
	'extVisCustomDelete': 'Slett',
	'extVisNoCustomVisuals': 'Ingen tilpassede visualseringer',
	'extVisNoCustomVisualsMsg': 'Det er i øyeblikket ingen tilpassede visualiseringer i organisasjonen din',
	'extVisAddCustomVisual': 'Legg til en tilpasset visualisering',
	'extVisNoCustomVisualsAdminMsg': 'Det er i øyeblikket ingen tilpassede visualiseringer. Legg til en for å komme i gang',
	'extVisNoSDKConnection': 'Det er ikke opprettet noen tilkobling til den lokale filen',
	'extVisNoSDKPreviewMsg': 'Hvis du vil forhåndsvise visualiseringer, må du opprette en tilkobling.',
	'extVisMore': 'Mer',
	'extVisDeleteDialogTitle': 'Slett tilpasset visualisering',
	'extVisDeleteDialogBody': 'Er du sikker på at du vil slette denne tilpassede visualiseringen? Den kan være i bruk av andre dashbord og rapporter.',
	'extVisDeleteConfirmation': 'Den tilpassede visualiseringen ble slettet.',
	'extVisDeleteError': 'Den tilpassede visualiseringen kunne ikke slettes. %{msg}',
	'extVisCloseToast': 'Lukk nå',
	'extVisAdd': 'Den tilpassede visualiseringen ble lagt til.',
	'extVisAddError': 'Den tilpassede visualiseringen kunne ikke legges til. %{msg}',
	'extVisUpdate': 'Den tilpassede visualiseringen ble oppdatert.',
	'extVisUpdateError': 'Den tilpassede visualiseringen kunne ikke oppdateres. %{msg}',
	'extVisAddProgress': 'Importerer %{name}',
	'extVisUpdateProgress': 'Oppdaterer %{name}',
	'extPermissionTitle': 'Begrenset tilgang eller slettet tilpasset visualisering',
	'extPermissionBody': 'Denne tilpassede visualiseringen kan ikke vises, enten fordi den er slettet eller fordi den har begrenset tilgang.',
	'customVizSaveWarning': 'Dine tilpassede visualiseringer kan ikke lagres. De er ikke importert.',
	'schematicTestCaption': 'Test skjemafunksjon',
	'schematicServiceRequestError': 'Skjematjenestefeil',
	'extVisPreviewMessage': 'Dette er en forhåndsvisning. Visualiseringen er ikke lagt til i produktet ennå.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Udefinert',
	'kpiDefaultTargetLabel': 'Mål',
	'kpiNonNumericTarget': 'Målverdien må være et tall.',
	'kpiManualTargetSlotFilled': 'Verdi brukt i felt',
	'kpiAutoValueSize': 'Automatisk',
	'kpiUnableDrawSparklineLabel': 'Kan ikke tegne sparkline',
	'kpiUnableDrawSparklineInfo': 'En sparkline krever minst to tidspunkter. Endre dataene eller juster filtrene for å se sparkline-grafikken.',
	'conditionalFormattingTextColor': 'Tekstfarge',
	'suppression': 'Utelatelse',
	'suppressNone': 'Ingen',
	'suppressRowsAndColumns': 'Rader og kolonner',
	'suppressRows': 'Rader',
	'suppressColumns': 'Kolonner',
	'enableSuppression': 'Aktiver utelatelse',
	'disableSuppression': 'Deaktiver utelatelse',
	'loadVisDefinitionError': 'Kan ikke laste inn definisjon for visualisering %{id}',
	'emptyVisualization': 'Tom visualisering',
	'expandCollapse': 'Utvid og komprimer',
	'expandBtnLabel': 'Utvid',
	'collapseBtnLabel': 'Komprimer',
	'prop_sizeInputNonNumericValue': 'Verdien må være et tall.',
	'prop_sizeValueShouldBeHigher': 'Verdien må være større enn %{value}.',
	'fontPropLabel': 'Fontfamilie',
	'fontSizePropLabel': 'Fontstørrelse',
	'sectionItemAxisTitle': 'Elementaksetittel',
	'sectionItemAxisLabel': 'Elementakseetikett',
	'sectionValueAxisTitle': 'Verdiaksetittel',
	'sectionValueAxisLabel': 'Verdiakseetikett',
	'styletext-widget.legend': 'Forklaring',
	'styletext-itemAxis.ticks.labels': 'Akseetiketter',
	'styletext-valueAxis.title': 'Aksetitler',
	'styletext-itemAxis.title': 'Aksetitler',
	'styletext-labels': 'Dataetiketter',
	'styletext-valueAxis.line.title': 'Linjetitler',
	'styletext-cellValue': 'Verdier',
	'styletext-values': 'Verdier',
	'styletext-rowHeading': 'Radoverskrifter',
	'styletext-columnHeading': 'Kolonneoverskrifter',
	'fontFamily': 'familie',
	'fontSize': 'størrelse',
	'visExportFileName': 'Visualisering',
	'ds-missingDataSet': 'Fant ikke datasett. Kontroller at datasettet er opprettet på riktig måte.',
	'ds-missingDashboardId': 'Lagre dashbordet før du oppretter datasettet.',
	'ds-unsupportedDataSourceType': 'Datakildetypen %{type} støttes ikke.',
	'dataCache': 'Datahurtigbuffer',
	'dataCache_on': 'På',
	'dataCache_off': 'Ingen hurtigbuffer',
	'dataCache_auto': 'Automatisk',
	'queryOptimization': 'Spørringsoptimalisering'
});
